import * as GSTORE from "../states";

export default function TMenuItem({ children, className, ...props }) {

    const { colourAccent, colourAccentSecondary } = GSTORE.globalStore()

    return <button className={`bg-transparent w-full text-left pl-5 hover:text-warmGray-600 hover:opacity-100 hover:bg-cyan-300 py-[6px] ${className}`} {...props}>{children}</button>
}